import { connect } from 'react-redux';

import { getCompanyNameSelector } from 'selectors/company';

import TitleBasic from './index';

const mapStateToProps = state => ({
    companyName: getCompanyNameSelector(state)
});

export default connect(mapStateToProps, null)(TitleBasic);
